import React from 'react'
import {PageTitle} from 'layout/master-layout'
import {useTranslation} from 'react-i18next'
import ViewOrganisation from './ViewOrganisation'

const ViewOrganisationWrapper = () => {
 const {t} = useTranslation()

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    <PageTitle
     breadcrumbContainerClass={
      'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0]'
     }
     breadcrumbs={[
      {
       title: t('breadCrumbs.home'),
       path: '/home-page',
       isActive: false,
      },
      {
       title: t('breadCrumbs.activityManagement'),
       path: '/activity-management',
       isActive: false,
      },
      {
       title: t('breadCrumbs.viewOrganisation'),
       path: '',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     View Organisation
    </PageTitle>

    <ViewOrganisation />
   </div>
  </div>
 )
}

export default ViewOrganisationWrapper
